import styled from 'styled-components';

export const AddressList = styled.div`
  margin: 2rem 0;
`;

export const AddressContainer = styled.label`
  width: 100%;
  padding: 1rem;
  border: 1px solid ${Styles.color.grey.four};
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: -1px; // for overlapping borders
  border-right: 0;
  border-left: 0;
  justify-content: center;
  border-radius: 0;
`;

export const RadioButtonContainer = styled.div`
  width: 250px;
  margin-left: 2rem;

  ${Styles.desktop`
    width: 300px;
  `};
`;
